module.exports = __webpack_public_path__ + "img/terminar_chamada.f704e036.gif";